import React from "react";
import { useWindowDimensions } from "@app/contexts";
import { useTranslation } from "react-i18next";
import { Switch, Case, CaseElse } from "react-context-switch";
import { SideGroupTitle } from "@app/components/groupTitle";
import "./accounts.scss";
import { AccountsGrid } from "./accountsGrid";

export const BankAccountsDefinition = () => {
  const { appIsPersonalKarma, jgDrawerHeight } = useWindowDimensions();
  const { t } = useTranslation();
  // if (process.env.REACT_APP_MODE === 'REACT') {
  //   appIsPersonalKarma = true;
  // }

  return (
    <div
      style={{
        maxWidth: "1200px",
        height: `${jgDrawerHeight}px`,
        overflow: "auto",
        margin: "auto",
      }}
    >
      <SideGroupTitle title={t("accountsForm")} sideKey={"issuerForm"} />
      <Switch value={appIsPersonalKarma}>
        <Case when={true}>
          <div className="accounts-form">
            <div className="accounts-form-disclaimer"></div>
            <div className="break" />
            <div className="accounts-form-form">
              <AccountsGrid />
            </div>
            <div className="accounts-form-disclaimer"></div>
          </div>
        </Case>
        <CaseElse>
          <div className="accounts-form">
            <p>
              {
                "Nu se poate determina forma de licentiere pentru aceasta versiune."
              }
            </p>
          </div>
        </CaseElse>
      </Switch>
    </div>
  );
};
